import { AppConsts } from '@shared/AppConsts';
import * as rtlDetect from 'rtl-detect';
import { StyleLoaderService } from '@shared/utils/style-loader.service';
import { ThemeHelper } from '@app/shared/layout/themes/ThemeHelper';
import { ThemeAssetContributorFactory } from './ThemeAssetContributorFactory';

export class DynamicResourcesHelper {
    static loadResources(callback: () => void): void {
        Promise.all([DynamicResourcesHelper.loadStyles()]).then(() => {
            callback();
        });
    }

    static loadStyles(): Promise<any> {
        /* these css files are now imported in styles.scss in order to load them in the correct order of precedence

        let theme = ThemeHelper.getTheme();

        const isRtl = rtlDetect.isRtlLang(abp.localization.currentLanguage.name);

        if (isRtl) {
            document.documentElement.setAttribute('dir', 'rtl');
        }

        const cssPrefix = ThemeHelper.darkMode() ? '.dark' : '';
        const cssPostfix = isRtl ? '.rtl' : '';
        const styleLoaderService = new StyleLoaderService();

        let styleUrls = [
            AppConsts.appBaseUrl +
                '/assets/metronic/themes/' +
                theme +
                '/css/style' +
                cssPrefix +
                '.bundle' +
                cssPostfix.replace('-', '.') +
                '.min.css',
            AppConsts.appBaseUrl +
                '/assets/metronic/themes/' +
                theme +
                '/plugins/global/plugins' +
                cssPrefix +
                '.bundle' +
                cssPostfix.replace('-', '.') +
                '.min.css',
            AppConsts.appBaseUrl +
                '/assets/primeng/themes/mdc-' +
                (ThemeHelper.darkMode() ? 'dark' : 'light') +
                '-indigo/theme.css', // PrimeNG Dark mode styles
            AppConsts.appBaseUrl + '/assets/primeng/datatable/css/primeng.datatable' + cssPostfix + '.min.css', // PrimeNG RTL styles
            AppConsts.appBaseUrl + '/assets/common/styles/metronic-customize.min.css',
            AppConsts.appBaseUrl + '/assets/common/styles/themes/' + theme + '/metronic-customize.min.css',
            AppConsts.appBaseUrl + '/assets/common/styles/metronic-customize-angular.min.css',
        ].concat(DynamicResourcesHelper.getAdditionalThemeAssets());

        // console.log('*****************************************************');
        // console.log('styleUrls: ');
        // console.log(styleUrls);
        // console.log('*****************************************************');

        // for theme5, this is the list:
        // 0: "http://localhost:4200/assets/metronic/themes/theme5/css/style.bundle.min.css"
        // 1: "http://localhost:4200/assets/metronic/themes/theme5/plugins/global/plugins.bundle.min.css"
        // 2: "http://localhost:4200/assets/primeng/themes/mdc-light-indigo/theme.css"
        // 3: "http://localhost:4200/assets/primeng/datatable/css/primeng.datatable.min.css"
        // 4: "http://localhost:4200/assets/common/styles/metronic-customize.min.css"
        // 5: "http://localhost:4200/assets/common/styles/themes/theme5/metronic-customize.min.css"
        // 6: "http://localhost:4200/assets/common/styles/metronic-customize-angular.min.css"
        // 7: "http://localhost:4200/assets/fonts/fonts-asap-condensed.min.css"
        
        styleLoaderService.loadArray(styleUrls);

        if (isRtl) {
            styleLoaderService.load(AppConsts.appBaseUrl + '/assets/common/styles/abp-zero-template-rtl.min.css');
        }
        */

        return Promise.resolve(true);
    }

    static getAdditionalThemeAssets(): string[] {
        let assetContributor = ThemeAssetContributorFactory.getCurrent();
        if (!assetContributor) {
            return [];
        }

        return assetContributor.getAssetUrls();
    }
}
